module.exports = __webpack_public_path__ + "static/media/appstore_ico.905aea31.svg";